var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { ref, set } from "vue";
import { GalaxyApi } from "@/api";
import { HistoryFilters } from "@/components/History/HistoryFilters";
import { filtersToQueryValues } from "@/components/History/model/queries";
import { errorMessageAsString } from "@/utils/simple-error";
const DEFAULT_FILTERS = { visible: true, deleted: false };
/**
 * Fetches datasets for the Collection Builder modal. It caches the datasets for each filter text.
 */
export const useCollectionBuilderItemsStore = defineStore("collectionBuilderItemsStore", () => {
    const cachedDatasetsForFilterText = ref({});
    const errorMessage = ref(null);
    const isFetching = ref({});
    const lastFetch = ref(null);
    function fetchDatasetsForFiltertext(historyId, historyUpdateTime, filterText = "") {
        return __awaiter(this, void 0, void 0, function* () {
            if (isFetching.value[filterText]) {
                return { data: [], error: null };
            }
            if (lastFetch.value &&
                lastFetch.value.id === historyId &&
                lastFetch.value.time === historyUpdateTime &&
                lastFetch.value.text === filterText) {
                return {
                    data: cachedDatasetsForFilterText.value[filterText] || [],
                    error: errorMessage.value,
                };
            }
            set(isFetching.value, filterText, true);
            const filterQuery = getFilterQuery(filterText);
            // Note: Had "/api/histories/{history_id}/contents/datasets" before but it was returning datasets and collections
            const { data, error: apiError } = yield GalaxyApi().GET("/api/histories/{history_id}/contents", {
                params: {
                    path: { history_id: historyId },
                    query: Object.assign(Object.assign({}, filterQuery), { v: "dev" }),
                },
            });
            const returnedData = data;
            let error = null;
            if (apiError) {
                error = errorMessageAsString(apiError);
                errorMessage.value = error;
            }
            else {
                set(cachedDatasetsForFilterText.value, filterText, returnedData);
            }
            set(isFetching.value, filterText, false);
            lastFetch.value = { id: historyId, time: historyUpdateTime || "", text: filterText };
            return { data: returnedData, error };
        });
    }
    function getFilterQuery(filterText) {
        let filters = filterText ? HistoryFilters.getQueryDict(filterText) : DEFAULT_FILTERS;
        if (filters.history_content_type) {
            delete filters.history_content_type;
        }
        filters = Object.assign(Object.assign({}, filters), { history_content_type: "dataset" });
        return filtersToQueryValues(filters);
    }
    return {
        cachedDatasetsForFilterText,
        isFetching,
        fetchDatasetsForFiltertext,
    };
});
